
class DocumentCategorizationCell extends UITableViewCell
{
    private titleTextField:MUITextField = null;
    private autoGenerateSwitchButton:MUISwitchButton = null;
    private ledgerAccountDropdown:MUIButton = null;

    private _item:DBDocumentLineClassification = null;

    awakeFromHTML(){
        this.titleTextField = MUIOutlet(this, "title-tf", "MUITextField");
        if (this.titleTextField) this.titleTextField.setOnChangeText(this, function(this:DocumentCategorizationCell, control:MUITextField, value:string){
            if (this._item != null) this._item.title = value;
        });

        this.autoGenerateSwitchButton = MUIOutlet(this, "auto-generate-sb", "MUISwitchButton");
        if (this.autoGenerateSwitchButton) this.autoGenerateSwitchButton.setOnChangeValue(this, function(this:DocumentCategorizationCell, control:MUISwitchButton, value:boolean){
            if (this._item != null) this._item.autoGenerateAccount = value;
        });

        this.ledgerAccountDropdown = MUIOutlet(this, "ledger-account-dd", "MUIButton");
        if (this.ledgerAccountDropdown) this.ledgerAccountDropdown.setAction(this, function(this:DocumentCategorizationCell){
            AppHelper.sharedInstance().showSelectLedgerAccountViewControllerFromView(this.ledgerAccountDropdown, this._item?.ledgerAccount, null, false, this._item?.title, this, this.updateLedgerAccount);
        });

        this.selectionStyle = UITableViewCellSelectionStyle.None;
    }

    set item(item:DBDocumentLineClassification){
        this._item = item;
        this.titleTextField.text = item.title;
        if (this.autoGenerateSwitchButton) this.autoGenerateSwitchButton.on = item.autoGenerateAccount;
        if (this.ledgerAccountDropdown) this.ledgerAccountDropdown.title = item.ledgerAccount?.description;
    }

    private updateLedgerAccount(controller:SelectViewController, account:LedgerAccount){
        if (this._item == null) return;
        this._item.ledgerAccount = account;
        if (this.ledgerAccountDropdown) this.ledgerAccountDropdown.title = account?.description;
    }
}
